import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FilterRow,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarEncerramentoFiscalManualDs } from "../../DataSources";
import memoria from "../../Memoria";

export default class EncerramentoFiscalManualBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.encerramentoFiscalDs = criarEncerramentoFiscalManualDs();
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("encerramento-fiscal/editar/" + e.data.id);
  }

  componentDidMount() {
    memoria.redirecionarSeNecessario(this.props.location, this.props.history);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar
            titulo="Encerramentos Fiscais"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={criarEncerramentoFiscalManualDs()}
              showBorders={true}
              rowAlternationEnabled={true}
              focusedRowEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <FilterRow visible={true} />
              <Editing
                allowDeleting={true}
                allowUpdating={true}
                useIcons={true}
              />
              <Column
                dataField={"id"}
                caption={"#"}
                allowEditing={false}
                alignment={"center"}
                width={120}
              />
              <Column dataField={"exercicio"} caption={"Exercicio"} />
              <Column dataField={"mes"} caption={"Mês"} />
              <Column dataField={"nomeArquivo"} caption={"Nome"} />
              <Column dataField={"multa"} caption={"Multa"} />
              <Column dataField={"juros"} caption={"Juros"} />
              <Column dataField={"correcao"} caption={"Correção"} />
              <Column dataField={"valorAtual"} caption={"ValorAtual"} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    this.props.history.push("encerramento-fiscal/novo");
  }
}
